import { nanoid } from 'nanoid';

export const AVATAR_TYPES = Object.freeze({
  GENERATED: 'generated',
  UPLOADED: 'uploaded',
});

const GRADIENTS = [
  ['#06b6d4', '#3b82f6'],
  ['#ec4899', '#a855f7'],
  ['#14b8a6', '#22d3ee'],
  ['#f97316', '#ef4444'],
  ['#fbbf24', '#f97316'],
  ['#6366f1', '#22d3ee'],
  ['#4ade80', '#16a34a'],
  ['#f472b6', '#fb7185'],
];

const clampSeed = (seed) => {
  if (seed && typeof seed === 'string') {
    return seed;
  }
  return nanoid(10);
};

const hashString = (value) => {
  if (!value) return 0;
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

const selectGradient = (seed) => {
  const index = hashString(seed) % GRADIENTS.length;
  const [from, to] = GRADIENTS[index];
  return {
    from,
    to,
    style: {
      backgroundImage: `linear-gradient(135deg, ${from}, ${to})`,
    },
  };
};

export const getInitials = (value) => {
  if (!value) return 'GS';
  const normalized = value
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .slice(0, 2);
  return normalized.toUpperCase() || 'GS';
};

export const buildGeneratedAvatar = ({ seed, displayName, email }) => {
  const safeSeed = clampSeed(seed ?? email ?? displayName ?? '');
  const initials = getInitials(displayName || email || 'GS');
  const gradient = selectGradient(safeSeed);
  return {
    seed: safeSeed,
    initials,
    gradient,
  };
};

export const ensureAvatarSeed = (seed, fallback) => clampSeed(seed ?? fallback);

export default {
  AVATAR_TYPES,
  buildGeneratedAvatar,
  ensureAvatarSeed,
  getInitials,
};
